export default function GearIcon(props) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.334 4.545a9.99 9.99 0 013.542-2.048A3.993 3.993 0 0012 3.999a3.993 3.993 0 003.124-1.502 9.99 9.99 0 013.542 2.048 3.994 3.994 0 001.47 4.758c.495.339 1.061.561 1.655.65.28 1.35.28 2.742 0 4.09a3.996 3.996 0 00-3.389 3.654 3.991 3.991 0 00.264 1.757 9.989 9.989 0 01-3.542 2.047A3.994 3.994 0 0012 20a3.993 3.993 0 00-3.124 1.502 9.988 9.988 0 01-3.542-2.047A3.993 3.993 0 005.072 16a3.993 3.993 0 00-2.863-1.954c-.281-1.35-.281-2.742 0-4.091A3.993 3.993 0 005.072 8a3.993 3.993 0 00.262-3.454v-.001zM13.5 14.597a3 3 0 10-2.965-5.215 3 3 0 002.965 5.215z"
        fill={props.fill}
      />
    </svg>
  )
}